import React, { useState } from 'react';
import { MobileLayout } from '../components/MobileLayout';
import { ArrowLeft, CheckCircle, Circle, Camera, Calendar, Clock, User, Sparkles, AlertTriangle, FileText, CheckSquare, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { CircularScore } from '../components/LastCleaningWidget';
// Mock Data
const photosData = [{
  id: 'soggiorno',
  name: 'Soggiorno',
  before: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?auto=format&fit=crop&w=800&q=80',
  after: 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=800&q=80'
}, {
  id: 'cucina',
  name: 'Cucina',
  before: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&w=800&q=80',
  after: 'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?auto=format&fit=crop&w=800&q=80'
}, {
  id: 'bagno',
  name: 'Bagno',
  before: 'https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?auto=format&fit=crop&w=800&q=80',
  after: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=800&q=80'
}];
interface ChecklistItem {
  task: string;
  done: boolean;
  isDesiderata: boolean;
}
const checklistData: Record<string, ChecklistItem[]> = {
  Soggiorno: [{
    task: 'Pavimento aspirato e lavato',
    done: true,
    isDesiderata: false
  }, {
    task: 'Superfici spolverate',
    done: true,
    isDesiderata: false
  }, {
    task: 'Cuscini divano sistemati in modo specifico',
    done: true,
    isDesiderata: true
  }],
  Cucina: [{
    task: 'Piano cottura pulito',
    done: true,
    isDesiderata: false
  }, {
    task: 'Elettrodomestici lucidati',
    done: true,
    isDesiderata: false
  }, {
    task: 'Pavimento lavato',
    done: true,
    isDesiderata: false
  }],
  Bagno: [{
    task: 'Sanitari igienizzati',
    done: true,
    isDesiderata: false
  }, {
    task: 'Specchio pulito',
    done: true,
    isDesiderata: false
  }, {
    task: 'Asciugamani piegati a cigno',
    done: false,
    isDesiderata: true
  }],
  Generale: [{
    task: 'Spazzatura svuotata',
    done: true,
    isDesiderata: false
  }, {
    task: 'Finestre pulite',
    done: true,
    isDesiderata: false
  }, {
    task: 'Lenzuola sempre stirate',
    done: false,
    isDesiderata: true
  }]
};
const roomNotes: Record<string, string> = {
  Soggiorno: 'Divano macchia lato sinistro già presente prima della pulizia.',
  Cucina: '',
  Bagno: 'Silicone doccia da rifare, segnalato al proprietario.'
};
const roomSegnalazioni: Record<string, {
  title: string;
  severity: string;
  description: string;
}[]> = {
  Soggiorno: [],
  Cucina: [],
  Bagno: [{
    title: 'Silicone doccia deteriorato',
    severity: 'media',
    description: 'Il silicone nella zona doccia è ingiallito e si sta staccando. Consigliata sostituzione.'
  }]
};
export function PuliziaDettaglioPage() {
  const [activeTab, setActiveTab] = useState('overview');
  // Calculate stats
  const allTasks = Object.values(checklistData).flat();
  const completedTasks = allTasks.filter(t => t.done).length;
  const totalTasks = allTasks.length;
  const renderChecklistItem = (item: ChecklistItem, idx: number) => <li key={idx} className="flex items-start gap-3 p-3 bg-gray-50 rounded-lg border border-gray-100" data-id="element-1562">
      <div className="mt-0.5 flex-shrink-0" data-id="element-1563">
        {item.done ? <CheckCircle size={18} className="text-emerald-500" data-id="element-1564" /> : <Circle size={18} className="text-muted-foreground" data-id="element-1565" />}
      </div>
      <div className="flex-1" data-id="element-1566">
        <span className={`text-sm ${item.done ? 'text-foreground' : 'text-muted-foreground'}`} data-id="element-1567">
          {item.task}
        </span>
        {item.isDesiderata && <div className="flex items-center gap-1 mt-1.5" data-id="element-1568">
            <Sparkles size={12} className="text-muted-foreground" data-id="element-1569" />
            <span className="text-[10px] font-bold text-muted-foreground uppercase tracking-wider" data-id="element-1570">
              Desiderata Host
            </span>
          </div>}
      </div>
    </li>;
  return <MobileLayout data-id="element-1571">
      {/* Header */}
      <div className="flex items-center gap-3 mb-6" data-id="element-1572">
        <Link to="/dashboard" className="p-2 hover:bg-muted rounded-full transition-colors" data-id="element-1573">
          <ArrowLeft size={20} className="text-foreground" data-id="element-1574" />
        </Link>
        <div data-id="element-1575">
          <h1 className="text-xl lg:text-2xl font-bold text-foreground" data-id="element-1576">
            Dettaglio Pulizia
          </h1>
        </div>
      </div>

      {/* Top Info Bar - Full Width */}
      <div className="bg-white border border-border rounded-xl p-4 lg:p-6 mb-6 shadow-sm flex flex-col sm:flex-row sm:items-center justify-between gap-6 w-full" data-id="element-1577">
        <div className="grid grid-cols-2 sm:flex sm:gap-8 gap-4" data-id="element-1578">
          <div data-id="element-1579">
            <div className="text-[10px] text-muted-foreground uppercase tracking-wider font-medium mb-1" data-id="element-1580">
              Data e Ora
            </div>
            <div className="flex items-center gap-1.5 text-sm font-semibold text-foreground" data-id="element-1581">
              <Calendar size={14} className="text-muted-foreground" data-id="element-1582" />
              Oggi, 15 Gen
            </div>
            <div className="flex items-center gap-1.5 text-xs text-muted-foreground mt-0.5" data-id="element-1583">
              <Clock size={12} className="text-muted-foreground" data-id="element-1584" />
              10:30 - 13:00 (2h 30m)
            </div>
          </div>

          <div data-id="element-1585">
            <div className="text-[10px] text-muted-foreground uppercase tracking-wider font-medium mb-1" data-id="element-1586">
              Cleaner
            </div>
            <div className="flex items-center gap-1.5 text-sm font-semibold text-foreground" data-id="element-1587">
              <User size={14} className="text-muted-foreground" data-id="element-1588" />
              Francesca N.
            </div>
          </div>

          <div className="col-span-2 sm:col-span-1" data-id="element-1589">
            <div className="text-[10px] text-muted-foreground uppercase tracking-wider font-medium mb-1" data-id="element-1590">
              Guest
            </div>
            <div className="flex items-center gap-1.5 text-sm font-semibold text-foreground" data-id="element-1591">
              Marco R.
            </div>
            <div className="text-xs text-muted-foreground mt-0.5" data-id="element-1592">
              Booking.com
            </div>
          </div>
        </div>

        <div className="flex items-center gap-4 bg-gray-50 p-3 rounded-lg border border-gray-100" data-id="element-1593">
          <CircularScore score={98} data-id="element-1594" />
          <div data-id="element-1595">
            <div className="text-sm font-bold text-foreground" data-id="element-1596">Eccellente</div>
            <div className="text-xs text-muted-foreground" data-id="element-1597">
              Valutazione CleanAI
            </div>
          </div>
        </div>
      </div>

      {/* Tab Navigation */}
      <div className="flex overflow-x-auto pb-4 -mx-4 px-4 lg:mx-0 lg:px-0 gap-2 hide-scrollbar mb-2" data-id="element-1598">
        <button onClick={() => setActiveTab('overview')} className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${activeTab === 'overview' ? 'bg-primary text-primary-foreground' : 'bg-white border border-border text-foreground hover:bg-muted'}`} data-id="element-1599">
          Overview
        </button>
        {photosData.map(room => <button key={room.id} onClick={() => setActiveTab(room.id)} className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${activeTab === room.id ? 'bg-primary text-primary-foreground' : 'bg-white border border-border text-foreground hover:bg-muted'}`} data-id="element-1600">
            {room.name}
          </button>)}
      </div>

      {/* Content Area - Full Width */}
      <div className="w-full space-y-6" data-id="element-1601">
        {/* OVERVIEW TAB */}
        {activeTab === 'overview' && <>
            {/* Summary Stats */}
            <div className="bg-white border border-border rounded-xl p-5 shadow-sm" data-id="element-1602">
              <h2 className="text-base font-bold text-foreground mb-4" data-id="element-1603">
                Riepilogo Pulizia
              </h2>
              <div className="grid grid-cols-3 gap-4 divide-x divide-border" data-id="element-1604">
                <div className="text-center px-2" data-id="element-1605">
                  <div className="text-2xl font-bold text-foreground" data-id="element-1606">
                    {completedTasks}/{totalTasks}
                  </div>
                  <div className="text-xs text-muted-foreground mt-1" data-id="element-1607">
                    Task completati
                  </div>
                </div>
                <div className="text-center px-2" data-id="element-1608">
                  <div className="text-2xl font-bold text-foreground" data-id="element-1609">
                    2h 30m
                  </div>
                  <div className="text-xs text-muted-foreground mt-1" data-id="element-1610">
                    Durata effettiva
                  </div>
                </div>
                <div className="text-center px-2" data-id="element-1611">
                  <div className="text-2xl font-bold text-foreground" data-id="element-1612">
                    98
                    <span className="text-sm text-muted-foreground font-normal" data-id="element-1613">
                      /100
                    </span>
                  </div>
                  <div className="text-xs text-muted-foreground mt-1" data-id="element-1614">
                    Punteggio qualità
                  </div>
                </div>
              </div>
            </div>

            {/* General Checklist */}
            <div className="bg-white border border-border rounded-xl p-5 shadow-sm" data-id="element-1615">
              <h2 className="text-base font-bold text-foreground flex items-center gap-2 mb-4" data-id="element-1616">
                <CheckSquare size={18} className="text-muted-foreground" data-id="element-1617" />
                Checklist Generale
              </h2>
              <ul className="space-y-3" data-id="element-1618">
                {checklistData.Generale.map((item, idx) => renderChecklistItem(item, idx))}
              </ul>
            </div>

            {/* Room Summaries */}
            <div className="space-y-4" data-id="element-1619">
              <h2 className="text-base font-bold text-foreground" data-id="element-1620">
                Dettaglio Stanze
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-1621">
                {photosData.map(room => {
              const roomTasks = checklistData[room.name] || [];
              const roomCompleted = roomTasks.filter(t => t.done).length;
              const roomTotal = roomTasks.length;
              const hasIssues = (roomSegnalazioni[room.name]?.length ?? 0) > 0;
              const hasNotes = !!roomNotes[room.name];
              return <button key={room.id} onClick={() => setActiveTab(room.id)} className="bg-white border border-border rounded-xl p-4 shadow-sm hover:border-primary/50 transition-colors text-left flex flex-col h-full" data-id="element-1622">
                      <div className="aspect-video rounded-lg overflow-hidden border border-border mb-3 bg-muted" data-id="element-1623">
                        <img src={room.after} alt={`Dopo ${room.name}`} className="w-full h-full object-cover" data-id="element-1624" />
                      </div>
                      <div className="flex items-center justify-between mb-2" data-id="element-1625">
                        <h3 className="font-semibold text-foreground" data-id="element-1626">
                          {room.name}
                        </h3>
                        <ChevronRight size={16} className="text-muted-foreground" data-id="element-1627" />
                      </div>
                      <div className="flex items-center gap-2 text-sm text-muted-foreground mb-3" data-id="element-1628">
                        <CheckCircle size={14} className={roomCompleted === roomTotal ? 'text-emerald-500' : 'text-muted-foreground'} data-id="element-1629" />
                        <span data-id="element-1630">
                          {roomCompleted}/{roomTotal} completate
                        </span>
                      </div>
                      <div className="mt-auto flex gap-2" data-id="element-1631">
                        {hasIssues && <span className="inline-flex items-center px-2 py-0.5 rounded text-[10px] font-medium bg-amber-50 text-amber-700 border border-amber-200" data-id="element-1632">
                            <AlertTriangle size={10} className="mr-1" data-id="element-1633" />
                            Segnalazioni
                          </span>}
                        {hasNotes && !hasIssues && <span className="inline-flex items-center px-2 py-0.5 rounded text-[10px] font-medium bg-blue-50 text-blue-700 border border-blue-200" data-id="element-1634">
                            <FileText size={10} className="mr-1" data-id="element-1635" />
                            Note
                          </span>}
                      </div>
                    </button>;
            })}
              </div>
            </div>
          </>}

        {/* ROOM TABS */}
        {photosData.map(room => {
        if (activeTab !== room.id) return null;
        const roomTasks = checklistData[room.name] || [];
        const notes = roomNotes[room.name];
        const issues = roomSegnalazioni[room.name] || [];
        return <div key={room.id} className="space-y-6" data-id="element-1636">
              {/* Photos Section */}
              <div className="bg-white border border-border rounded-xl p-5 shadow-sm" data-id="element-1637">
                <h2 className="text-base font-bold text-foreground flex items-center gap-2 mb-4" data-id="element-1638">
                  <Camera size={18} className="text-muted-foreground" data-id="element-1639" />
                  Foto Prima / Dopo
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1640">
                  <div className="space-y-2" data-id="element-1641">
                    <div className="inline-block px-3 py-1 bg-amber-50 text-amber-700 text-xs font-bold rounded-md border border-amber-100" data-id="element-1642">
                      Prima
                    </div>
                    <div className="aspect-[4/3] rounded-lg overflow-hidden border border-border bg-muted" data-id="element-1643">
                      <img src={room.before} alt={`Prima ${room.name}`} className="w-full h-full object-cover" data-id="element-1644" />
                    </div>
                  </div>
                  <div className="space-y-2" data-id="element-1645">
                    <div className="inline-block px-3 py-1 bg-emerald-50 text-emerald-700 text-xs font-bold rounded-md border border-emerald-100" data-id="element-1646">
                      Dopo
                    </div>
                    <div className="aspect-[4/3] rounded-lg overflow-hidden border border-border bg-muted" data-id="element-1647">
                      <img src={room.after} alt={`Dopo ${room.name}`} className="w-full h-full object-cover" data-id="element-1648" />
                    </div>
                  </div>
                </div>
              </div>

              {/* Checklist Section */}
              <div className="bg-white border border-border rounded-xl p-5 shadow-sm" data-id="element-1649">
                <h2 className="text-base font-bold text-foreground flex items-center gap-2 mb-4" data-id="element-1650">
                  <CheckSquare size={18} className="text-muted-foreground" data-id="element-1651" />
                  Checklist {room.name}
                </h2>
                <ul className="space-y-3" data-id="element-1652">
                  {roomTasks.map((item, idx) => renderChecklistItem(item, idx))}
                </ul>
              </div>

              {/* Notes Section */}
              {notes && <div className="bg-white border border-border rounded-xl p-5 shadow-sm" data-id="element-1653">
                  <h2 className="text-base font-bold text-foreground flex items-center gap-2 mb-3" data-id="element-1654">
                    <FileText size={18} className="text-muted-foreground" data-id="element-1655" />
                    Note del Cleaner
                  </h2>
                  <div className="p-4 bg-gray-50 rounded-lg border border-gray-100 text-sm text-foreground" data-id="element-1656">
                    {notes}
                  </div>
                </div>}

              {/* Segnalazioni Section */}
              {issues.length > 0 && <div className="bg-white border border-border rounded-xl p-5 shadow-sm" data-id="element-1657">
                  <h2 className="text-base font-bold text-foreground flex items-center gap-2 mb-4" data-id="element-1658">
                    <AlertTriangle size={18} className="text-muted-foreground" data-id="element-1659" />
                    Segnalazioni
                  </h2>
                  <div className="space-y-3" data-id="element-1660">
                    {issues.map((issue, idx) => <div key={idx} className="p-4 bg-amber-50/50 rounded-lg border border-amber-100" data-id="element-1661">
                        <div className="flex items-start justify-between mb-2" data-id="element-1662">
                          <h3 className="font-semibold text-foreground" data-id="element-1663">
                            {issue.title}
                          </h3>
                          <span className="inline-flex items-center px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider bg-amber-100 text-amber-800 border border-amber-200" data-id="element-1664">
                            {issue.severity}
                          </span>
                        </div>
                        <p className="text-sm text-muted-foreground" data-id="element-1665">
                          {issue.description}
                        </p>
                      </div>)}
                  </div>
                </div>}
            </div>;
      })}
      </div>
    </MobileLayout>;
}